import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { mapBoundsGroupsSelector } from '@selectors/groups-selector';
import MapGroup from './group-figure';

const Groups = () => {
  const groups = useSelector(mapBoundsGroupsSelector);

  return groups.map(group => <MapGroup key={group.id} {...group} />);
};

export default memo(Groups);
